import { Divider, Box } from "@mui/material";
import { BlTextButton } from "Components/Shared/Buttons/BlTextButton";
import { EmailOrDownloadInvoiceForm } from "Components/Transactions/Anonymous/EmailOrDownloadInvoiceForm";
import { SignupOptions } from "Components/Transactions/Anonymous/SignUpOptions/SignupOptions";
import { useState } from "react";
import { Resources, useResource } from "Translations/Resources";

const ComponentResources = Resources.Transactions.Anonymous;

type Props = {
  transactionPublicID: string;
  setWasEmailInvoiceSent: (wasEmailInvoiceSent: boolean) => void;
};

export const SignupOrInvoice = ({
  transactionPublicID,
  setWasEmailInvoiceSent,
}: Props) => {
  const [isReceiptOnlyView, setIsReceiptOnlyView] = useState(false);
  const { t } = useResource();

  return (
    <>
      {isReceiptOnlyView ? (
        <EmailOrDownloadInvoiceForm
          transactionPublicID={transactionPublicID}
          onEmailSent={() => setWasEmailInvoiceSent(true)}
        />
      ) : (
        <SignupOptions />
      )}
      <Divider sx={{ opacity: 0.5 }} />
      <Box display="flex" justifyContent="center" mb={1.5}>
        <BlTextButton onClick={() => setIsReceiptOnlyView((p) => !p)}>
          {isReceiptOnlyView
            ? t(ComponentResources.BackToSignup)
            : t(ComponentResources.JustWantReceipt)}
        </BlTextButton>
      </Box>
    </>
  );
};
